export default __webpack_public_path__ + "static/media/zoom_out.f269ba76.svg";